export default __webpack_public_path__ + "static/media/garbage-2-frequency.709ede0e.svg";